import { toast as sonnerToast } from "sonner";

/**
 * Custom hook for using Sonner toast notifications
 * This hook provides a simplified API for showing toast notifications
 */
export function useSonnerToast() {
  /**
   * Show a toast notification
   */
  const toast = ({
    title,
    description,
    variant = "default",
    richColors = true,
    onDismiss,
    persistent = false,
    closeButton = false,
  }: {
    title?: string;
    description?: string;
    variant?: "default" | "destructive" | "success";
    richColors?: boolean;
    onDismiss?: () => void;
    persistent?: boolean;
    closeButton?: boolean;
  }) => {
    // Map variant to Sonner toast type
    const baseOptions = {
      closeButton,
      description,
      richColors,
      duration: persistent ? Infinity : undefined,
      onDismiss: () => onDismiss?.(),
    };

    if (variant === "destructive") {
      return sonnerToast.error(title, baseOptions);
    } else if (variant === "success") {
      return sonnerToast.success(title, baseOptions);
    } else {
      return sonnerToast(title, baseOptions);
    }
  };

  return { toast };
}
